import { render, staticRenderFns } from "./lazy-img.vue?vue&type=template&id=c9febb0c&scoped=true"
import script from "./lazy-img.vue?vue&type=script&lang=js"
export * from "./lazy-img.vue?vue&type=script&lang=js"
import style0 from "./lazy-img.vue?vue&type=style&index=0&id=c9febb0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9febb0c",
  null
  
)

export default component.exports